import { useEffect, useRef } from "react";
import { usePathname } from "next/navigation"; 

const useKeyboardNavigation = () => {
  const pathname = usePathname();
  const currentFocusedContainer = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex="0"]'
    ];

    const scrollToElement = (id: string) => {
      const targetElement = document.getElementById(id);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });

        const focusableElements = targetElement.querySelectorAll<HTMLElement>(focusableSelectors.join(","));
        if (focusableElements.length > 0) {
          focusableElements[0].focus();
          currentFocusedContainer.current = targetElement;
        } else {
          targetElement.setAttribute("tabindex", "-1");
          targetElement.focus();
          currentFocusedContainer.current = targetElement;
        }
      }
    };

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.altKey) {
        switch (event.key) {
          case "1":
            event.preventDefault();
            const isHome = pathname === "/" || pathname === "";
            scrollToElement(isHome ? "conteudoTopo" : "conteudo");
            break;

          case "2":
            event.preventDefault();
            scrollToElement("menu");
            break;

          case "3":
            event.preventDefault();
            scrollToElement("footer");
            break;

          case "4":
            event.preventDefault();
            currentFocusedContainer.current = null;
            window.open("/Acessibilidade", "_self");
            break;
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [pathname]);

  return null;
};

export default useKeyboardNavigation;
